"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _HBIconButton = require("../HBIconButton/HBIconButton.styles");
var _react = _interopRequireWildcard(require("react"));
var VisuallyHidden = _interopRequireWildcard(require("@radix-ui/react-visually-hidden"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _HBButton = require("../HBButton/HBButton.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _excluded = ["testIdName", "testId", "icon", "isSelected", "label", "size", "buttonTheme", "tooltip", "tooltipProps", "disabled", "inert", "loading", "tag", "className", "margin"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var iconButtonSizeToLoaderSize = {
  xxs: 'xxs',
  xs: 'xs',
  sm: 'xs',
  md: 'xs',
  lg: 'xs',
  xl: 'small'
};
var iconButtonThemeToLoaderColor = {
  'neutral-floating': _colors["default"].neutral900,
  'neutral-invisible': _colors["default"].neutral900,
  'neutral-solid': _colors["default"].neutral900,
  'subtle-floating': _colors["default"].neutral900,
  'subtle-invisible': _colors["default"].neutral900,
  'subtle-solid': _colors["default"].neutral900,
  'accent-floating': _colors["default"].blue20,
  'accent-invisible': _colors["default"].blue20,
  'accent-solid': _colors["default"].blue20,
  'error-solid': _colors["default"].red60,
  'light-invisible': _colors["default"].white
};
var HBIconButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    Icon = _ref.icon,
    isSelected = _ref.isSelected,
    label = _ref.label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xs' : _ref$size,
    _ref$buttonTheme = _ref.buttonTheme,
    buttonTheme = _ref$buttonTheme === void 0 ? 'neutral-invisible' : _ref$buttonTheme,
    tooltip = _ref.tooltip,
    tooltipProps = _ref.tooltipProps,
    disabled = _ref.disabled,
    inert = _ref.inert,
    loading = _ref.loading,
    tag = _ref.tag,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    margin = _ref.margin,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isLink = 'href' in props;
  assertCorrectIconSizeInDev({
    icon: Icon,
    size: size
  });
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: isLink ? 'link' : 'button',
    componentName: 'HBIconButton'
  });
  var _props = isLink ? _objectSpread(_objectSpread(_objectSpread({}, props), props.isNewTab && {
    target: '_blank'
  }), {}, {
    as: 'a'
  }) : tag ? _objectSpread(_objectSpread({}, props), {}, {
    as: tag
  }) : _objectSpread(_objectSpread({}, props), {}, {
    type: props.type || 'button'
  });
  var iconButtonClassName = "".concat(className).concat(isSelected ? ' selected' : '');
  var loaderSize = iconButtonSizeToLoaderSize[size];
  var loaderColor = iconButtonThemeToLoaderColor[buttonTheme];
  return /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], (0, _extends2["default"])({
    disabled: !tooltip,
    placement: "top",
    offsetY: 6
  }, tooltipProps, {
    target: /*#__PURE__*/_react["default"].createElement(_HBIconButton.IconButton, (0, _extends2["default"])({
      inert: inert
    }, _props, {
      ref: ref,
      disabled: disabled || loading,
      className: iconButtonClassName,
      "data-testid": finalTestId,
      size: size,
      theme: buttonTheme,
      $margin: margin
    }), loading && /*#__PURE__*/_react["default"].createElement(_HBButton.Loader, {
      size: loaderSize,
      color: loaderColor
    }), /*#__PURE__*/_react["default"].createElement(Icon, {
      color: null /* to make sure no color is applied **/
    }), /*#__PURE__*/_react["default"].createElement(VisuallyHidden.Root, null, label))
  }), tooltip);
});
var _default = exports["default"] = HBIconButton;
function assertCorrectIconSizeInDev(_ref2) {
  var icon = _ref2.icon,
    size = _ref2.size;
  if (process.env.NODE_ENV === 'development') {
    var throwOnIncorrectSize = function throwOnIncorrectSize(pixels) {
      var _icon$name;
      var digitsAtTheEnd = (_icon$name = icon.name) === null || _icon$name === void 0 || (_icon$name = _icon$name.match(/\d+$/)) === null || _icon$name === void 0 ? void 0 : _icon$name[0];
      if (digitsAtTheEnd && digitsAtTheEnd !== String(pixels)) {
        throw new Error("HBIconButton: If the size is \"".concat(size, "\" the icon must be of size ").concat(pixels, ", received: ").concat(icon.name));
      }
    };
    switch (size) {
      case 'xxs':
        throwOnIncorrectSize(12);
        break;
      case 'xs':
        throwOnIncorrectSize(16);
        break;
      case 'xl':
        throwOnIncorrectSize(32);
        break;
      default:
        throwOnIncorrectSize(24);
    }
  }
}
//# sourceMappingURL=HBIconButton.js.map